import { useNavigate } from 'react-router-dom';

import { MDBox, MDButton } from '@components/index';
import LoginLayout from '@layouts/SignInLayout';

import RoutesPath from '@constants/RoutesPath';
import bgImage from '@assets/images/login-woman.jpeg';

function PageNotFound(): JSX.Element {
  const navigate = useNavigate();
  const handleHomePress = async () => {
    navigate(RoutesPath.SIGN_IN);
  };

  return (
    <LoginLayout
      title='Error 404'
      description='Page not found - If the problem persist, please access support.'
      illustration={bgImage}
      isError
    >
      <MDBox>
        <MDBox mt={4} mb={1}>
          <MDButton
            variant='gradient'
            color='secondary'
            size='large'
            fullWidth
            onClick={handleHomePress}
          >
            HOME
          </MDButton>
        </MDBox>
      </MDBox>
    </LoginLayout>
  );
}

export default PageNotFound;
